var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checked)?_c('i',{staticClass:"ni ni-check-bold icon-shape-success"}):_c('i',{staticClass:"ni ni-fat-remove icon-shape-danger"})
}
var staticRenderFns = []

export { render, staticRenderFns }